function stripMarkup(text) {
  return String(text || '')
    .replace(/^\s*#{1,6}\s+/gm, '')
    .replace(/^\s*[-*_=]{3,}\s*$/gm, '')
    .replace(/\*\*/g, '')
    .replace(/__/g, '')
    .replace(/^\s*[-*•]\s+/gm, '')
    .replace(/\s*[\u2013\u2014]\s*/g, ', ')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

function looksLikeHeading(line) {
  if (!line || line.length > 52) return false;
  if (/[.?]$/.test(line)) return false;
  return /^[A-Z]/.test(line) && !/\b(ask|share|there is|if you|take someone|bring these|here is|on the)\b/i.test(line);
}

function looksLikeQuestion(line) {
  return /\?$/.test(line) || /^(Where|What|Has|Have|Is|Are|Can|Could|Who|How|At what|Which|Should|Do|Does)\b/i.test(line);
}

function speakQuestion(question) {
  const body = question.replace(/\?+$/, '?').trim();
  const first = body.charAt(0).toLowerCase() + body.slice(1);
  return first;
}

export function clinicBriefParagraphs(text) {
  const cleaned = stripMarkup(text);
  if (!cleaned) return [];
  const lines = cleaned.split(/\n+/).map((line) => line.trim()).filter(Boolean);
  const paragraphs = [];
  let i = 0;
  while (i < lines.length) {
    if (looksLikeHeading(lines[i]) && lines[i + 1] && looksLikeQuestion(lines[i + 1])) {
      const heading = lines[i].replace(/:$/, '').toLowerCase();
      const questions = [];
      i += 1;
      while (i < lines.length && !looksLikeHeading(lines[i]) && looksLikeQuestion(lines[i])) {
        questions.push(speakQuestion(lines[i]));
        i += 1;
      }
      const spoken = questions.map((q, idx) => (idx === 0 ? `On ${heading}, ask ${q}` : `Ask ${q}`));
      paragraphs.push(spoken.join(' '));
      continue;
    }
    paragraphs.push(lines[i].replace(/\s{2,}/g, ' '));
    i += 1;
  }
  return paragraphs.filter((p) => p && p !== '-' && !/^[-*_=]+$/.test(p));
}

export function formatWhen(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  if (d.toDateString() === now.toDateString()) return `Today, ${time}`;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `Yesterday, ${time}`;
  const date = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  return `${date}, ${time}`;
}
